<template>
    <div class="folder-navigator-component">
        <fade-and-slide>
            <div
                v-if="forceBackArrow && scopedRoot != null"
                :class="[$style['main-item'], $style['parent-item']]"
            >
                <a
                    @click.prevent="
                        $emit('navigate-to-collection', scopedRoot.parent)
                    "
                    :href="
                        scopedRoot.parent != null
                            ? getCollectionUrl(
                                  scopedRoot.parent,
                                  viewMode,
                                  baseUrl,
                                  value,
                                  root ?? [],
                                  matchedLogicalName,
                                  matchedLogicalNameEntityGuid,
                                  matchedLogicalNameModuleGuid,
                                  matchedLogicalNameSubModuleGuid
                              ) ?? '#'
                            : '#'
                    "
                >
                    <span :class="$style['back-arrow']"></span>
                </a>
                {{ scopedRoot.Name }}
            </div>
        </fade-and-slide>
        <div
            :class="[$style['selected-items']]"
            v-if="collections != null && selectedItems.length > 0"
        >
            <div :class="[$style['selected-items-header']]">
                {{
                    labels.get(
                        "frontendProductList.filters.productCollection.resetFilters"
                    )
                }}
            </div>
            <div :class="[$style['selected-items-list']]">
                <template
                    v-for="{ collection, subCollection } in selectedItems"
                    :key="subCollection.Id"
                >
                    <div
                        :class="$style['selected-item']"
                        :data-key="subCollection.Id"
                    >
                        <a
                            @click.prevent="
                                setChecked(
                                    collections.indexOf(collection),
                                    subCollection.Id
                                )
                            "
                            :href="
                                subCollection.Filler === true
                                    ? '#'
                                    : getCollectionUrl(
                                          subCollection,
                                          viewMode,
                                          baseUrl,
                                          value,
                                          root ?? [],
                                          matchedLogicalName,
                                          matchedLogicalNameEntityGuid,
                                          matchedLogicalNameModuleGuid,
                                          matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            "
                            ><filler
                                v-if="subCollection.Filler === true"
                                :max="14"
                            ></filler
                            ><template v-else>{{ subCollection.Name }}</template
                            >&nbsp;<span :class="$style['remove-selected']"
                                >&#10005;</span
                            ></a
                        >
                    </div>
                </template>
            </div>
        </div>
        <div :class="[$style['items']]" v-if="collections != null">
            <template v-for="collection in collections">
                <template v-if="getVisible(collection)">
                    <div
                        v-if="
                            collection.Settings?.combineFilteringWithParent ==
                            true
                        "
                        v-show="collection.Settings.invisibleOnFilters == false"
                    >
                        <CheckboxItem
                            :id="'collectionCheckBox_' + collection.Id"
                            :href="
                                collection.Filler === true
                                    ? '#'
                                    : getCollectionUrl(
                                          collection,
                                          viewMode,
                                          baseUrl,
                                          value,
                                          root ?? [],
                                          matchedLogicalName,
                                          matchedLogicalNameEntityGuid,
                                          matchedLogicalNameModuleGuid,
                                          matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            "
                            :checked="
                                isChecked(
                                    value,
                                    collections.indexOf(collection),
                                    collection.Id
                                )
                            "
                            :name="getName(collection)"
                            @select="
                                setChecked(
                                    collections.indexOf(collection),
                                    collection.Id,
                                    $event,
                                    undefined
                                )
                            "
                        ></CheckboxItem>
                    </div>
                    <div
                        :class="[$style['main-item']]"
                        v-else
                        v-show="
                            collection.Settings == null ||
                            collection.Settings.invisibleOnFilters == false
                        "
                    >
                        <a
                            @click.prevent="
                                $emit('navigate-to-collection', collection)
                            "
                            :href="
                                collection.Filler === true
                                    ? '#'
                                    : getCollectionUrl(
                                          collection,
                                          viewMode,
                                          baseUrl,
                                          value,
                                          root ?? [],
                                          matchedLogicalName,
                                          matchedLogicalNameEntityGuid,
                                          matchedLogicalNameModuleGuid,
                                          matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            "
                            :class="$style['link']"
                            ><filler
                                v-if="collection.Filler === true"
                                :max="15"
                            ></filler
                            ><template v-else
                                >{{ collection.Name }}
                                <template v-if="debugProductCounts">{{
                                    collection.ProductCount
                                }}</template></template
                            ></a
                        >
                        <SubItems
                            :collection="collection"
                            :collections="collections"
                            :items="
                                getFlattenedCollectionsArrayWithCount(
                                    collection.SubCollections
                                )
                            "
                            :parent-depth="getDepth(collection)"
                            :set-checked="setChecked"
                            :is-checked="isChecked"
                            :debug-product-counts="debugProductCounts"
                            :view-mode="viewMode"
                            :base-url="baseUrl"
                            :value="value"
                            :root="root"
                            :matched-logical-name="matchedLogicalName"
                            :matched-logical-name-entity-guid="
                                matchedLogicalNameEntityGuid
                            "
                            :matched-logical-name-module-guid="
                                matchedLogicalNameModuleGuid
                            "
                            :matched-logical-name-sub-module-guid="
                                matchedLogicalNameSubModuleGuid
                            "
                        ></SubItems>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<style module>
.back-arrow {
    background-image: url("../../../../../../../mthemes/odendo.dk/images/back-arrow.png");
    display: inline-block;
    width: 0.9em !important;
    height: 0.9em !important;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 2px;
    margin-right: 2px;
    vertical-align: baseline;
    background-position: center;
}

.selected-items {
    font-size: 12px;
    margin-bottom: 20px;
}

.selected-items-header {
    font-weight: bold;
}

.selected-items-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
}
.remove-selected {
    font-weight: bold;
    vertical-align: baseline;
    font-size: 12px;
}
.selected-item {
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 4px;
    background-color: #ddeac3;
    padding: 2px 7px;
    font-size: 12px;
}

.product-count {
    color: #565656;
    font-size: 12px;
    text-align: right;
}
.link {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    max-width: 100%;
    display: block;
}

.main-item,
.item {
    font-size: 14px;
    color: #272727;
    margin-bottom: 8px;
}

.parent-item {
    font-weight: 600;
}

.items {
    transition: margin 0.4s ease-in-out;
    margin-left: 0px;
}

.items.indented {
    margin-left: 5px;
}

.main-item .link {
    font-weight: 600;
    margin-top: 15px;
    margin-bottom: 15px;
}

.item {
    font-weight: normal;
}

.item:not(.disabled) {
    cursor: pointer;
}

.item.disabled {
    cursor: default;
}

.item.active {
    font-weight: 700;
    cursor: default;
}

.transition-enter,
.transition-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.transition-move {
    transition: transform 0.3s;
}

@keyframes bounce-in {
    0% {
        opacity: 0;
        filter: grayscale(1);
    }

    100% {
        opacity: 1;
        filter: grayscale(0);
    }
}
</style>

<script setup lang="ts">
import labels from "../../../../shared/labels";
import Filler from "../../../../shared/Filler.vue";
import { type PropType, type Ref, computed, ref } from "vue";
import { type MappedProductCollectionModel } from "../../models";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import {
    flattenAllCollectionsWithDepth,
    flattenAllCollectionsWithParents,
} from "../../collection-methods";
import { getCollectionUrl } from "../../collection-url";
import SubItems from "./sub-items.vue";
import CheckboxItem from "../common/checkbox-item.vue";

const debugProductCounts = ((window as any).debugProductCounts ??
    (((window as any).debugProductCounts = ref(false)) as Ref<boolean>)) as
    | boolean
    | Ref<boolean>;

const props = defineProps({
    siteGuid: Number,
    productListGuid: Number,
    value: Array as PropType<number[][]>,
    root: Array as PropType<MappedProductCollectionModel[]>,
    scopedRoot: Object as PropType<MappedProductCollectionModel>,
    forceBackArrow: Boolean,
    baseUrl: String,
    getVisible: {
        type: Function,
        required: true,
    },
    viewMode: {
        type: Number,
        required: true,
    },
    // findCollectionById: {
    //     type: Function as PropType<
    //         (
    //             collectionId: number,
    //             mappedRoot: ProductCollectionModel[] | MappedProductCollectionModel[] | undefined
    //         ) => ProductCollectionModel
    //     >,
    //     required: true,
    // },
    // getFlattenedCollections: {
    //     type: Function as PropType<
    //         (
    //             collections: ProductCollectionModel[]
    //         ) => Generator<ProductCollectionModel>
    //     >,
    //     required: true,
    // },
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
});

// const collectionsOwner = computed(() => {
//     if (props.root == null) return null;
//     if (props.scopedRoot == null) return null;
//     const selectedCol = props.scopedRoot;

//     let collection: MappedProductCollectionModel | null | undefined = null;
//     if (selectedCol != null) {
//         collection = selectedCol;
//         if (
//             !Array.isArray(collection.SubCollections) ||
//             collection.SubCollections.length <= 0
//         )
//             collection = collection.parent;
//     }

//     if (collection === props.scopedRoot) collection = null;

//     return collection;
// });
const mappedRoot = computed(() => {
    if (props.root == null) return props.root;
    if (props.scopedRoot != null) {
        return props.scopedRoot.SubCollections;
    }
    return props.root;
});
const collections = computed(() => {
    if (props.root == null)
        return typeof props.root === "undefined" ? undefined : null;
    return mappedRoot.value;
});
const selectedItems = computed(() => {
    const result = [];
    if (collections.value != null) {
        for (const collection of collections.value) {
            if (props.getVisible(collection)) {
                for (const {
                    subCollection,
                } of getFlattenedCollectionsArrayWithCount(
                    collection.SubCollections
                )) {
                    if (
                        isChecked(
                            props.value,
                            collections.value.indexOf(collection),
                            subCollection.Id
                        )
                    ) {
                        result.push({ collection, subCollection });
                    }
                }
            }
        }
    }
    return result;
});

// onMounted(() => {
//     console.debug(mappedRoot.value);
// });

const emit = defineEmits([
    "emit-value",
    "navigate-to-collection",
    "update-product-count",
]);

function getName(col: MappedProductCollectionModel) {
    if (col.Filler) return undefined;
    let name = col.Name;

    if (
        debugProductCounts == true ||
        (typeof debugProductCounts !== "boolean" && debugProductCounts.value)
    ) {
        name += ` ${col.ProductCount}`;
    }
    return name;
}

function isChecked(
    value: number[][] | undefined | null,
    index: number,
    collectionId: number
) {
    if (value == null) return false;
    const group = value[index];
    if (group == null) return false;
    if (group.length == 0) return false;
    return group.includes(collectionId);
}
function setChecked(
    index: number,
    collectionId: number,
    checked: boolean | undefined | null = null,
    depth?: number | undefined
) {
    //console.debug("setChecked",index,collectionId,checked,depth);
    if (index < 0) throw new Error(`trying to set checked on index ${index}`);
    if (checked == null) checked = !isChecked(props.value, index, collectionId);
    // console.debug("SET CHECKED", index, collectionId, checked);
    const checkedValues = props.value == null ? [] : props.value.concat();
    while (checkedValues.length < index + 1) {
        checkedValues.push([]);
    }
    const group = checkedValues[index];

    if (checked) {
        group.push(collectionId);
    } else {
        while (group.includes(collectionId)) {
            const index = group.indexOf(collectionId);
            group.splice(index, 1);
        }
    }

    if (checked && depth != null && depth > 0) {
        const flatCol = Array.from(
            flattenAllCollectionsWithParents(
                props.scopedRoot?.SubCollections ??
                    ([] as MappedProductCollectionModel[])
            )
        );
        const col = flatCol.find((x) => x.collection.Id == collectionId);
        if (col != null) {
            const parent = col.parents[col.parents.length - 1];

            if (parent != null) {
                while (group.includes(parent.Id)) {
                    const index = group.indexOf(parent.Id);
                    group.splice(index, 1);
                }
            }
        }
    }

    emit("emit-value", checkedValues);
    emit("update-product-count");
}

function getFlattenedCollectionsArrayWithCount(
    collections: MappedProductCollectionModel[]
): { subCollection: MappedProductCollectionModel; i: number; depth: number }[] {
    if (collections == null || collections.length == 0) return [];
    let items = Array.from(flattenAllCollectionsWithDepth(collections));
    if (items.some((x) => x.collection.hasOwnProperty("ProductCount"))) {
        items = items.sort((a, b) => {
            // if (a.collection.parent != null && b.collection.parent != null) {
            //     if (a.collection.parent.Id != b.collection.parent.Id) {
            //         return (
            //             (b.collection.parent.ProductCount ?? 0) -
            //             (a.collection.parent.ProductCount ?? 0)
            //         );
            //     }
            // }
            return (
                (b.collection.ProductCount ?? 0) -
                (a.collection.ProductCount ?? 0)
            );
        });
        const lowestDepth = items
            .concat()
            .sort((a, b) => a.depth - b.depth)[0].depth;

        let somethingChanged = true;
        while (somethingChanged) {
            somethingChanged = false;
            const itemsCopy = items.concat();
            for (const item of itemsCopy) {
                if (item.collection.parent == null) continue;
                if (item.depth == lowestDepth) continue;
                const parent = item.collection.parent;
                const itemMatchParent = items.find(
                    (x) => x.collection.Id == parent.Id
                );
                if (itemMatchParent == null) continue;

                const reversedItems = items.concat().reverse();
                const reversedIndex = reversedItems.indexOf(item);
                const parentAbove = reversedItems.find(
                    (x, i) => i > reversedIndex && x.depth < item.depth
                );

                if (parentAbove?.collection.Id == item.collection.parent.Id)
                    continue;

                somethingChanged = true;
                const index = items.indexOf(itemMatchParent);
                items.splice(items.indexOf(item), 1);
                items.splice(index + 1, 0, item);
            }
        }
        items = items
            .reduce(
                (prev, curr) => {
                    const key = curr.depth;
                    if (prev.length === 0 || prev[prev.length - 1].key != key) {
                        prev.push({ items: [], key: key });
                    }
                    prev[prev.length - 1].items.push(curr);
                    return prev;
                },
                [] as {
                    items: {
                        collection: MappedProductCollectionModel;
                        depth: number;
                    }[];
                    key: number;
                }[]
            )
            .map((x) =>
                x.items.sort(
                    (a, b) =>
                        (b.collection.ProductCount ?? 0) -
                        (a.collection.ProductCount ?? 0)
                )
            )
            .flatMap((x) => x);
    }
    return items.map((item, i) => ({
        subCollection: item.collection,
        i,
        depth: item.depth,
    }));
}

function getDepth(col: MappedProductCollectionModel) {
    let depth = 0;
    while (col.parent != null) {
        depth++;
        col = col.parent;
    }
    return depth;
}

(window as any).testShowAllCollections = function () {
    getFlattenedCollectionsArrayWithCount(mappedRoot.value ?? []).forEach(
        (x) => {
            x.subCollection.Visible = true;
            x.subCollection.ProductCount = 100 * Math.random();
        }
    );
};
</script>
